import { render, staticRenderFns } from "./Cumpleanos.vue?vue&type=template&id=61269243"
import script from "./Cumpleanos.vue?vue&type=script&lang=js"
export * from "./Cumpleanos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports